import React from "react";
import { SbBlokData } from "@storyblok/react";
import CustomStoryBlockComponent from "@/components/CustomStoryBlockComponent";
import { getStyleCss } from "../helper/css_style";

interface TextWithImageProps {
  blok: {
    body: (SbBlokData & any)[];
    custom_style: [];
  };
}

function TextWithImage({ blok }: TextWithImageProps) {
  const styles = blok?.custom_style?.length > 0 ? getStyleCss(blok.custom_style) : {};

  return (
    <div className="py-1">
      <ul style={styles} className="flex items-center">
        {blok.body.map((nestedBlok) => (
          <li key={nestedBlok._uid} className="list-none">
            <CustomStoryBlockComponent blok={nestedBlok} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TextWithImage;
